<template lang="pug">
include /mixins
+b.g-row--appearance_spaced
  +b.g-cell.g-cols--12.--6-xl
    trip-monthly-distribution(
      :trip_label='trip_label'
      :path='["trip_potential_participant", "props", "monthly_distribution"]'
    )
    trip-state(
      :trip_label='trip_label'
    )
  +b.g-cell.g-cols--12.--6-xl
    //- trip-condition(
    //-   :trip_label='trip_label'
    //- )
    trip-progress-view(
      :trip_label='trip_label'
    )
</template>

<script>

import {
  mapState, mapActions,
} from 'vuex'

export default {
  props: {
    trip_label: {
      type: String,
      required: true,
    },
    // path: {
    //   type: Array,
    //   required: true,
    // },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapState('trip', ['trip']),
  },
  created() {
    this.getTrip(this.trip_label);
  },
  methods: {
    ...mapActions('trip', ['getTrip']),
  },
}

</script>
